import React, { FC, memo, ReactElement } from "react";
import { ListItem, Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";

import { SearchIcon } from "../../../icons";
import { useTextSearchResultStyles } from "./TextSearchResultStyles";
import { SEARCH } from "../../../constants/path-constants";
import { addToLocalStorage } from "../addToLocalStorage";
import RemoveSearchResultButton from "../RemoveSearchResultButton/RemoveSearchResultButton";

interface TextSearchResultProps {
    text: string;
    tweetCount?: number;
    recentSearch?: boolean;
    closePopup?: () => void;
    resetText?: () => void;
}

const TextSearchResult: FC<TextSearchResultProps> = memo(({ text, tweetCount, recentSearch, closePopup, resetText }): ReactElement => {
    const classes = useTextSearchResultStyles();
    const history = useHistory();

    const onClickSearchResult = (): void => {
        const isHashTag = Array.from(text)[0] === "#";
        addToLocalStorage(isHashTag ? "tags" : "text", text);
        const searchParam = isHashTag
            ? `?tag=${encodeURIComponent(text)}`
            : `?text=${encodeURIComponent(text)}`;

        history.replace(`${SEARCH}${searchParam}`, {state: isHashTag ? { tag: text } : { text: encodeURIComponent(text) }});
        // history.replace({
        //     pathname: SEARCH,
        //     state: isHashTag ? { tag: text } : { text: encodeURIComponent(text) }
        // });
        if (closePopup) closePopup();
        if (resetText) resetText();
    };

    return (
        <ListItem className={classes.searchTextResult} onClick={onClickSearchResult}>
            <span className={classes.searchIcon}>
                {SearchIcon}
            </span>
            <div>
                <Typography variant={"h6"} component={"div"}>
                    {text}
                </Typography>
                {tweetCount && (
                    <Typography variant={"subtitle1"} component={"div"}>
                        {tweetCount} Tweets
                    </Typography>
                )}
            </div>
            {recentSearch && <RemoveSearchResultButton stateItem={Array.from(text)[0] === "#" ? "tags" : "text"} item={text} />}
        </ListItem>
    );
});

export default TextSearchResult;
